import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ContractPlanDetail } from '~/features/ContractPlanDetail';
import { ContractPlanDetailHeader } from '~/features/ContractPlanDetailHeader';
import { getContractPlansLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { planId } = useParams<{ planId: string }>();
  const planIdNumber = Number.parseInt(planId ?? '', 10);

  if (Number.isNaN(planIdNumber)) {
    return <Navigate to={getContractPlansLink()} replace />;
  }

  return (
    <>
      <Suspense fallback={<Loader />}>
        <ContractPlanDetailHeader planId={planIdNumber} />
      </Suspense>
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <ContractPlanDetail planId={planIdNumber} />
        </Suspense>
      </main>
    </>
  );
};
